import store from 'app/store';
import moment from 'moment';
import { UseFormReturn } from 'react-hook-form';
import create from 'zustand';
import UtilOrder from '../../utilOrder';

// chưa đủ dữ liệu để tạo type cho BaseItem dùng any đỡ !!!
// interface BaseItem {
//   id: string | number;
//   name: string;
// }

// init dữ liệu gọn gàn
const initialStore = {
  baseItems: [],
  isSettling: false,
  methods: null,
  inputError: null
};

type IinputError = {
  gIdx?: number;
  dIdx?: number;
  fieldName?: string;
};

interface FormState {
  // data chính
  baseItems: any[];
  isSettling: boolean;
  inputError: IinputError | null;
  // data method của RHForm
  methods: UseFormReturn<any> | null;

  // Actions data
  setIsSettling: (status: boolean) => void;
  setDataInitBase: (data: any[] | null, changeSettling?: boolean) => void;
  hasBaseItems: () => boolean;
  setInputError: (data: IinputError) => void;

  // Action method
  setMethods: (methods: UseFormReturn<any>) => void;
  getLatestBaseItems: () => any[];

  callBackAddQuick: (
    bs?: any,
    vehicleType?: any,
    maSanPham?: any,
    amount?: any,
    isDelete?: boolean,
    companyId?: number,
    groupId?: string,
    valueQuick?: any,
    timeRegis?: any
  ) => any;

  callBackImportDetailBaseExcel: (data: any[], isDelete?: boolean) => any;
  // reset chung
  resetStore: () => void;
}

// useSelector((state: RootState) => state.createOrder.);
//  useSelector((state: RootState) => state.createOrder.);

// xu hướng mới những thứ dùng chung nhiều vị trí và phức tạm nên xử dụng store riêng bằng zutand để quản lý
export const useBaseOrderStore = create<FormState>((set, get) => ({
  ...initialStore,
  setIsSettling: status => set({ isSettling: status }),
  setDataInitBase: (data: any, changeSettling?: boolean) => {
    const payload = { baseItems: data };
    changeSettling && (payload['isSettling'] = true);
    set(payload);
    if (changeSettling) {
      const idleCallback = (window as any).requestIdleCallback || ((cb: any) => setTimeout(cb, 1));
      idleCallback(() => {
        set({ isSettling: false });
      });
    }
  },
  hasBaseItems: () => get().baseItems.length > 0,
  setInputError: (data: IinputError | null) => {
    set({
      inputError: data
    });
  },

  setMethods: methods => set({ methods }),

  getLatestBaseItems: () => {
    const methods = get().methods;
    return methods ? methods.getValues('BaseItems') : [];
  },

  callBackAddQuick: async (
    bs?: any,
    vehicleType?: any,
    maSanPham?: any,
    amount?: any,
    isDelete?: boolean,
    companyId?: number,
    groupId?: string,
    valueQuick?: any,
    timeRegis?: any
  ) => {
    const baseMap = new Map<string, any>(); // mảng rỗng
    if (!isDelete) {
      // const currentValues = get().baseItems || [];
      const detailBase = get().methods.getValues('BaseItems');
      // console.log(' time 1 quick', currentValues, performance.now(), detailBase, get()?.getLatestBaseItems());

      for (const item of detailBase) {
        baseMap.set(item?.registrationPlate ?? '', item);
      }
    } else {
      const detailBase = get().methods.getValues('BaseItems');
      console.log({ detailBase });
    }

    // data chi tiết mới make ra
    const newDetailsRaw = await UtilOrder.makeDetailBase(valueQuick, maSanPham, amount);

    // check xe đã có trong data chưa
    if (baseMap.has(bs ?? '')) {
      const existingItem = baseMap.get(bs ?? '');
      // có thì cập nhật
      const combined = existingItem.details.concat(newDetailsRaw);
      baseMap.set(bs ?? '', {
        ...existingItem,
        details: proccessDetailBase(combined, false)
      });
    } else {
      // Thêm xe mới nếu chưa có xe này
      baseMap.set(bs ?? '', {
        id: crypto.randomUUID(),
        registrationPlate: bs ?? '',
        vehicleType: vehicleType || undefined,
        companyId: companyId || null,
        doiXe: groupId || null,
        hanDangKiem: timeRegis ? moment(new Date(timeRegis)) : null,
        details: proccessDetailBase(newDetailsRaw, false)
      });
    }

    const arrayData = Array.from(baseMap.values());

    get().setDataInitBase(arrayData, true);
  },

  callBackImportDetailBaseExcel: async (data: any[], isDelete?: boolean) => {
    //
    const baseMap = new Map<string, any>(); // mảng rỗng
    if (!isDelete) {
      // const currentValues = get().baseItems || [];
      const detailBase = get().methods.getValues('BaseItems');
      // console.log(' time 1 Excel', isDelete, performance.now(), currentValues);

      for (const item of detailBase) {
        baseMap.set(item?.registrationPlate ?? '', item);
      }
    }

    // loop data Excel
    for (const [index, newItem] of data.entries()) {
      const bs = newItem.bs ?? '';

      // đã có bs này
      if (baseMap.has(bs)) {
        const existingItem: any = baseMap.get(bs);
        console.log('có bs lỗi mịa rồi', existingItem);

        const combined = existingItem.details.concat(newItem.details); // mới chèn cũ thì mới đúng !!!

        existingItem.details = proccessDetailBase(combined, false);
      } else {
        console.log(' mới hoàn toàn ');

        // xe mới hoàn toàn
        baseMap.set(bs, {
          id: crypto.randomUUID(),
          registrationPlate: bs || undefined,
          vehicleType: newItem.loaixe || undefined,
          companyId: newItem.companyId || null,
          doiXe: newItem.doiXe || null,
          hanDangKiem: newItem.hanDangKiem || null,
          details: proccessDetailBase(newItem.details, false)
        });
      }

      if (index % 500 === 0) {
        await new Promise(resolve => setTimeout(resolve, 0));
      }
    }

    const arrayData = Array.from(baseMap.values());

    get().setDataInitBase(arrayData, true);
  },

  resetStore: () => set(initialStore)
}));

// hàm mới dùng map để find item . đổi flat array dùng for loop qua từng nhóm
export const proccessDetailBase = (detail: any[], hasEx?: boolean) => {
  const productCategoryPMP = store.getState().createOrder.listProductMixDataPaging;

  const productCategoryPMS = store.getState().createOrder.dataProductMixSearch;

  const listProMix = [...productCategoryPMP, ...productCategoryPMS];
  const productMap = new Map();
  for (const p of listProMix) productMap.set(p.maSanPham, p);

  // Gom nhóm theo Key (maSanPham + maBo)
  const groupedMap = new Map<string, any[]>();
  for (const item of detail) {
    const key = (item?.maSanPham || '') + (item?.maBo || '');
    if (!groupedMap.has(key)) groupedMap.set(key, []);
    groupedMap.get(key)!.push(item);
  }

  const tempList: any[] = [];

  for (const children of groupedMap.values()) {
    if (children?.length === 0 || !children[0]) continue;

    const firstChild = { ...children[0], id: children[0]['id'] || crypto.randomUUID() };
    const findPM = productMap.get(firstChild?.maSanPham);

    if (findPM?.input === 0) {
      const firstAmount = firstChild['amount'] || 0;
      const adjust = firstChild['amount'] ? 1 : 0;
      firstChild['amount'] = firstAmount + (children.length - adjust);

      // tìm setName từ maBo
      firstChild['setName'] = productMap.get(firstChild?.maBo)?.nameDisplay || null;
      firstChild['isRequireSP'] = 0;

      tempList.push(firstChild);
    } else {
      // đúng format gốc
      for (const child of children) {
        tempList.push({
          id: child['id'] || crypto.randomUUID(),
          maSanPham: child['maSanPham'] || '',
          serial: child['serial'],
          phone: child['phone'],
          staffExecute: child['staffExecute'] || '',
          maBo: child['maBo'] || '',
          isRequireSP: findPM?.input || 0,
          setName: productMap.get(child?.['maBo'])?.nameDisplay || null
        });
      }
    }
  }

  const newTempList = tempList.sort((a, b) => {
    const valA = a.isRequireSP || 0;
    const valB = b.isRequireSP || 0;
    if (valA !== 0 && valB !== 0) return valA - valB;
    return valB - valA;
  });
  return newTempList;
};
